import DataGrid, {
    Column, Pager, FilterRow, Lookup,
    HeaderFilter,
    Scrolling,
    Paging,
    DataGridTypes,
    Sorting,
    LoadPanel,
} from 'devextreme-react/data-grid';
import { userService } from '@/projects/admin/services/user-service';
import CustomStore from 'devextreme/data/custom_store';
import { useEffect, useRef, useState } from 'react';
import authService from '../../services/auth-service';
import { accountService } from '@/projects/admin/services/account-service';
import { t } from 'i18next';
import { DateFormat, DateTimeFormatString } from '@/modules/localization/formatter';
import {
    Form,
    Item, GroupItem, Label,
    FormTypes,
    ButtonItem,
} from 'devextreme-react/form';
import { ButtonType } from 'devextreme/common';
import { extFormatDate } from '@/core/helper/date-helper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';


const UserEventList = () => {
    const allowedPageSizes: (DataGridTypes.PagerPageSize | number)[] = [20, 50, 100];
    const [searchData, setSearchData] = useState<any>({ userId: '', type: [], startDate: '', endDate: '' })
    const [searchForm, setSearchForm] = useState<any>({ userId: '', type: [], startDate: '', endDate: '', skip: 0, take: 20 })
    const formRef: any = useRef<Form>();
    const dataGridRef = useRef<DataGrid>(null);
    const userItemRef = useRef<Item>(null);

    const mainStore =  createCustomStore({
        load: async (loadOptions: any) => {
            searchForm.skip = loadOptions.skip;
            searchForm.take = loadOptions.take;
            return await authService.getUserEvents(searchForm);
        },
    });




    const userStore = createCustomStore({
        key: 'id',
        load: userService.userList,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
        onLoading(loadOptions) {
            loadOptions.requireTotalCount = true;
            loadOptions.sort = [{ "selector": "userName", "desc": false }, { "selector": "accountName", "desc": false }]
        },
        useDefaultSearch: true,
    })


    const accountStore = createCustomStore({
        key: 'id',
        load: accountService.lookupAccounts,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["Id", "=", key];
            }
        },

        useDefaultSearch: true,
    });

    const lookupTypeData = ["LOGIN", "LOGOUT"
    ];

    const usersEditorOptions = {
        dataSource: userStore,
        valueExpr: 'kid',
        showClearButton: true,
        searchExpr: ["userName"],
        displayExpr: (item: any) => item ? `${item.userName} (${item.accountName})` : '',
        searchEnabled: true
    };


    const typeEditorOptions = {
        dataSource: lookupTypeData,
        searchEnabled: true
    };
    const searchButtonOptions = {
        text: t("search"),
        type: 'default' as ButtonType,
        useSubmitBehavior: true,
        width: '120px',
        verticalAlignment: 'bottom',
    };



    const onSearch = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        const data = formRef.current.props.formData;
        console.log(searchData);
        const formattedData = {
            ...data,
            startDate: searchData.startDate ? extFormatDate(searchData.startDate) : "",
            endDate: searchData.endDate ? extFormatDate(searchData.endDate) : "",
            type: searchData.type.join(",")
        };

        setSearchForm(formattedData);
        await dataGridRef.current?.instance.refresh();
    }


    return (
        <>


            <form action="event-search" onSubmit={onSearch}>
                <Form formData={searchData} ref={formRef}>
                    <GroupItem colCount={5}>

                        <Item ref={userItemRef} dataField="userId" editorType='dxSelectBox' editorOptions={usersEditorOptions}>
                            <Label text={t("user")} />
                        </Item>
                        <Item dataField="type" editorType='dxTagBox' editorOptions={typeEditorOptions}>
                            <Label text={t("action")} />
                        </Item>
                        <Item dataField="startDate" editorType='dxDateBox'>
                            <Label text={t("start_date")} />
                        </Item>
                        <Item dataField="endDate" editorType='dxDateBox' >
                            <Label text={t("end_date")} />
                        </Item>
                        <ButtonItem verticalAlignment='bottom' horizontalAlignment='left' buttonOptions={searchButtonOptions} />
                    </GroupItem>
                </Form>
            </form>


            <DataGrid
                ref={dataGridRef}
                wordWrapEnabled={true}
                dataSource={mainStore}
                height={400}
                remoteOperations={true}
            >
                <Sorting mode='none'></Sorting>
                <Scrolling mode="virtual" rowRenderingMode="virtual" />
                <Paging defaultPageSize={20} />
                {/* <Paging defaultPageSize={20} />
                <Pager
                    showNavigationButtons={true}
                    showInfo={false}
                    allowedPageSizes={allowedPageSizes}
                    showPageSizeSelector={true}
                    visible={true}
                /> */}
                <Column dataField='accountId' caption={t("account")} allowSearch={false} allowFiltering={false}>
                    <Lookup
                        dataSource={accountStore}
                        valueExpr="id"
                        displayExpr="name"

                    /></Column>
                <Column dataField='userId' caption={t("user")} allowSearch={false} allowFiltering={false}>
                    <Lookup
                        dataSource={userStore}
                        valueExpr="kid"
                        displayExpr="userName"

                    /></Column>

                <Column dataField='type' caption={t("action")} allowFiltering={false}>
                </Column>
                <Column dataField='time' caption={t("request_date")} dataType='datetime' allowSearch={false}
                    calculateCellValue={(e: any) => {
                        return new Date(e.time)
                    }} />
                <Column dataField='ipAddress' caption='Ip Address' allowSearch={false} allowFiltering={false} />
            </DataGrid>


        </>

    )
}
export default UserEventList